/* Native customer POST remains authoritative. No email or customer data is stored here. */
(() => {
  if (window.__nakedSignupEvents || window.Shopify?.designMode) return;
  window.__nakedSignupEvents = true;
  const key = 'naked:signup:pending:v1';
  const ttl = 30 * 60 * 1000;
  let publishing = false;

  const read = () => {
    try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; }
  };
  const write = (value) => {
    try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch { return false; }
  };
  const cleanUrl = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('nc_signup');
    // Keep Shopify's success flag, device choice, hash and attribution parameters.
    try { window.history.replaceState(window.history.state, '', url); } catch { /* Native feedback still works. */ }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.checkValidity()) return;
    const marker = form.querySelector('[data-naked-signup]');
    if (!marker || !form.id || form.method.toLowerCase() !== 'post') return;
    const action = new URL(form.action, window.location.href);
    if (action.origin !== window.location.origin || !action.pathname.endsWith('/contact')) return;
    try {
      let returnField = form.querySelector('input[name="return_to"]');
      const target = new URL(returnField?.value || window.location.href, window.location.origin);
      if (target.origin !== window.location.origin) return;
      const previous = read();
      // Two immediate submits of the same form share an ID rather than two leads.
      const reuse = previous?.formId === form.id && !previous.consumed && Date.now() - previous.createdAt < 5000;
      const attempt = reuse ? previous : {
        id: `nfs_${window.crypto.randomUUID()}`,
        formId: form.id,
        path: target.pathname,
        source: marker.dataset.nakedSignup,
        createdAt: Date.now(),
        consumed: false,
      };
      if (!write(attempt)) return; // Fail closed for measurement, not for the signup.
      target.searchParams.set('customer_posted', 'true');
      target.searchParams.set('nc_signup', attempt.id);
      if (!returnField) {
        returnField = document.createElement('input');
        returnField.type = 'hidden';
        returnField.name = 'return_to';
        form.appendChild(returnField);
      }
      returnField.value = `${target.pathname}${target.search}${target.hash}`;
    } catch { /* Tracking must never interrupt Shopify's native form. */ }
  }, { capture: true });

  const confirm = () => {
    // Defer the accepted-result event until Shopify's async pixel bootstrap has loaded.
    if (document.readyState !== 'complete') return;
    const attempt = read();
    const url = new URL(window.location.href);
    if (!attempt || attempt.consumed || attempt.id !== url.searchParams.get('nc_signup') || attempt.path !== url.pathname) return;
    if (Date.now() - attempt.createdAt > ttl || Date.now() < attempt.createdAt) return;
    const marker = document.getElementById(attempt.formId)?.querySelector('[data-naked-signup]');
    if (!marker) return;
    if (marker.dataset.signupResult === 'error') {
      write({ ...attempt, consumed: true });
      cleanUrl();
      return;
    }
    if (marker.dataset.signupResult !== 'success' || url.searchParams.get('customer_posted') !== 'true' || publishing) return;
    publishing = true;
    let retries = 0;
    const publish = () => {
      if (typeof window.Shopify?.analytics?.publish !== 'function') {
        if (++retries <= 60) window.setTimeout(publish, 500);
        else publishing = false;
        return;
      }
      // Consume before calling: refresh, back navigation and duplicate asset loads cannot replay it.
      if (!write({ ...attempt, consumed: true })) { publishing = false; return; }
      cleanUrl();
      try {
        const accepted = window.Shopify.analytics.publish('naked_first_access_signup', {
          signup_event_id: attempt.id,
          form_source: attempt.source,
        });
        if (document.getElementById('web-pixels-helper-sandbox-container')) {
          console.info('[Naked signup QA] Shopify publish result:', accepted);
        }
      } catch (error) {
        if (document.getElementById('web-pixels-helper-sandbox-container')) {
          console.warn('[Naked signup QA] Shopify publish failed:', error.name);
        }
        /* Never resend a possibly delivered event or affect the confirmation UI. */
      }
    };
    publish();
  };
  confirm();
  window.addEventListener('load', confirm, { once: true });
  window.addEventListener('pageshow', confirm);
})();
